import {
  baseFields,
  couponFields,
  discountedProductFields,
  FormModel,
  onlineFlags,
  PosFields,
  requiredProductFields,
  templateConstraintFields,
} from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    'perceivedValue',
    ...onlineFlags,
    ...requiredProductFields,
    ...discountedProductFields,
    'instoreRedemptionType',
    'availableCustomerSupport',
    'images',
    ...couponFields,
    'posFields',
    'productIds',
    ...templateConstraintFields,
  ]
}

export function getPosFieldKeys(): (keyof PosFields)[] {
  return [
    'instoreRedemptionType',
    'productIds',
    'instoreRequiredProductIds',
    'instoreDiscountedProductIds',
    'onlineRequiredProductIds',
    'onlineDiscountedProductIds',
    ...couponFields,
  ]
}
